module.exports = __webpack_public_path__ + "static/media/close.4ecaa1d1.svg";